import { CascadiaColor, CascadiaStandardIcon } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";

import { Icon } from "../../../foundations/icons/Icon/Icon";
import { Divider } from "../../divider/Divider";

export type type = "info" | "warning" | "danger" | "success";
interface SummaryMessageProps {
  children: React.ReactNode;
  type: type;
}

export function SummaryMessage({ children, type }: SummaryMessageProps) {
  const backgroundMap = {
    info: "var(--background-info-weak)",
    warning: "var(--background-warning-weak)",
    success: "var(--background-success-weak)",
    danger: "var(--background-danger-weak)",
  };
  const iconMap = {
    info: ["help", "icon-info"],
    warning: ["warning", "icon-warning"],
    success: ["verified_user", "icon-success"],
    danger: ["error", "icon-danger"],
  };
  const [icon, color] = iconMap[type];

  return (
    <div
      className={css(styles, {
        background: backgroundMap[type],
      })}
    >
      <Icon
        name={icon as CascadiaStandardIcon}
        color={color as CascadiaColor}
        size="space-6"
      />
      <div>{children}</div>
      <Divider />
    </div>
  );
}

const styles = css({
  padding: "var(--space-4)",
  gap: "var(--space-2)",
  display: "flex",
  i: {
    position: "relative",
    top: "-2px",
  },
});
